import React, { useEffect, useRef, useState } from "react";
import { EditorState, Modifier } from "draft-js";
import { Picker } from "emoji-mart";
import "emoji-mart/css/emoji-mart.css";

/**
 * Emoji button for a react-draft-wysiwyg toolbar, in place of its built-in "emoji" option.
 * The built-in one only offers a fixed list of 129 emojis with no categories or search; this
 * opens emoji-mart's full picker. Pass it through the Editor's toolbarCustomButtons prop:
 *
 *   <Editor toolbarCustomButtons={[<EmojiPickerButton />]} ... />
 *
 * The Editor gives every custom button the current editorState and an onChange that applies a
 * new one. The emoji is inserted at the cursor (replacing any selected text) the same way the
 * built-in option does it. Emojis are drawn with the system font (native), so nothing is
 * downloaded from emoji-mart's CDN.
 */
export default function EmojiPickerButton({ editorState, onChange }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Close the picker on a click anywhere outside it
  useEffect(() => {
    if (!open) return undefined;
    const closeIfOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", closeIfOutside);
    return () => document.removeEventListener("mousedown", closeIfOutside);
  }, [open]);

  const insertEmoji = (emoji) => {
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      emoji.native,
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, "insert-characters"));
    setOpen(false);
  };

  return (
    <div ref={wrapperRef} className="rdw-inline-wrapper" style={{ position: "relative" }}>
      <div
        className="rdw-option-wrapper"
        title="Emoji"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
        style={{ fontSize: 15, lineHeight: 1 }}
      >
        <span role="img" aria-label="emoji">🙂</span>
      </div>
      {open && (
        <div style={{ position: "absolute", top: "100%", left: 0, zIndex: 100, marginTop: 4 }}>
          <Picker
            native
            onSelect={insertEmoji}
            showPreview={false}
            showSkinTones
            emojiTooltip
            title=""
            perLine={8}
          />
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/EmojiPickerButton.js